var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Box } from "theme-ui";
export const Stack = (_a) => {
    var { direction = "vertical", space = 8, children } = _a, props = __rest(_a, ["direction", "space", "children"]);
    return (_jsx(Box, Object.assign({ sx: {
            display: "grid",
            width: "100%",
            gap: space,
            gridTemplateColumns: direction === "horizontal"
                ? `repeat(auto-fit, minmax(128px, 1fr))`
                : "unset"
        } }, props, { children: children })));
};
//# sourceMappingURL=Stack.js.map